// TEMPORARY COMPATIBILITY CODE: this mapper is not an API-contract source and must not be extended.
export type Mapping = { properties?: Record<string, Mapping & { name?: string }>; items?: Mapping };
export type ServiceCodecs = Record<string, { request?: Mapping; response?: Mapping; omit?: string[] }>;

const map = (value: unknown, mapping: Mapping | undefined, toWire: boolean): unknown => {
  if (value === null || value === undefined || !mapping) return value;
  if (Array.isArray(value)) return mapping.items ? value.map(item => map(item, mapping.items, toWire)) : value;
  if (typeof value !== 'object' || Object.getPrototypeOf(value) !== Object.prototype) return value;
  const source = value as Record<string, unknown>;
  const result: Record<string, unknown> = { ...source };
  for (const [wireName, child] of Object.entries(mapping.properties || {})) {
    const internalName = child.name || wireName;
    const from = toWire ? internalName : wireName;
    const to = toWire ? wireName : internalName;
    if (!Object.prototype.hasOwnProperty.call(source, from)) continue;
    if (from !== to) delete result[from];
    result[to] = map(source[from], child, toWire);
  }
  return result;
};

export const encode = (codecs: ServiceCodecs, operation: string, value: unknown): unknown => {
  const codec = codecs[operation];
  const encoded = map(value, codec?.request, true);
  if (!codec?.omit?.length || !encoded || typeof encoded !== 'object' || Array.isArray(encoded)) return encoded;
  const result = { ...(encoded as Record<string, unknown>) };
  codec.omit.forEach(name => delete result[name]);
  return result;
};
export const decode = (codecs: ServiceCodecs, operation: string, value: unknown): unknown => map(value, codecs[operation]?.response, false);
